import { Container, ContainerSucces } from './styles'
import { useForm, ValidationError } from '@formspree/react'
import { toast, ToastContainer } from 'react-toastify'
import { useEffect, useState } from 'react'
import validator from 'validator'
import { useLanguage } from '../../i18n/LanguageContext'

export function Form() {
  const [state, handleSubmit] = useForm('xknkpqry')
  const { t } = useLanguage()

  const [validEmail, setValidEmail] = useState(false)
  const [message, setMessage] = useState('')

  function verifyEmail(email: string) {
    if (validator.isEmail(email)) {
      setValidEmail(true)
    } else {
      setValidEmail(false)
    }
  }

  useEffect(() => {
    if (state.succeeded) {
      toast.success(t.form.successToast, {
        position: toast.POSITION.BOTTOM_LEFT,
        pauseOnFocusLoss: false,
        closeOnClick: true,
        hideProgressBar: false,
        toastId: 'succeeded',
      })
    }
  })
  if (state.succeeded) {
    return (
      <ContainerSucces>
        <h3>{t.form.thanks}</h3>
        <button
          onClick={() => {
            window.scrollTo({ top: 0, behavior: 'smooth' })
          }}
        >
          {t.form.backToTop}
        </button>
        <ToastContainer />
      </ContainerSucces>
    )
  }

  return (
    <Container>
      <h2>{t.form.heading}</h2>
      <form onSubmit={handleSubmit}>
        <input
          placeholder={t.form.emailPlaceholder}
          id="email"
          type="email"
          name="email"
          onChange={(e) => {
            verifyEmail(e.target.value)
          }}
          required
        />
        <ValidationError prefix={t.form.emailErrorPrefix} field="email" errors={state.errors} />
        <textarea
          required
          placeholder={t.form.messagePlaceholder}
          id="message"
          name="message"
          onChange={(e) => {
            setMessage(e.target.value)
          }}
        />
        <ValidationError
          prefix={t.form.messageErrorPrefix}
          field="message"
          errors={state.errors}
        />
        <button
          type="submit"
          disabled={state.submitting || !validEmail || !message}
        >
          {t.form.submit}
        </button>
      </form>
      <ToastContainer />
    </Container>
  )
}
